import axios from 'axios'

import { API_URL } from '../../../../constants'
import { ApiResponse } from '../../api/response.types'
import { ClientSnapshot, ClientSnapshotResponseData } from './_models'

export const GET_CLIENT_SNAPSHOT = `${API_URL}/api/internal/external_user/client-snapshot/__token__`

// Подсказка открывается наведением, и по одной строке водят мышью много раз: снимок грузится один
// раз за жизнь страницы. Неудачный запрос из кэша убирается — следующее наведение попробует снова.
const cache = new Map<string, Promise<ClientSnapshot | null>>()

export const getClientSnapshot = (token: string, paymentTicket?: string | null): Promise<ClientSnapshot | null> => {
  const key = `${token}|${paymentTicket ?? ''}`
  const cached = cache.get(key)
  if (cached) {
    return cached
  }

  const request = axios
    .get<ApiResponse<ClientSnapshotResponseData>>(GET_CLIENT_SNAPSHOT.replace('__token__', token), {
      params: paymentTicket ? { paymentTicket } : undefined,
    })
    .then((response) => {
      if (!response.data.success) {
        throw new Error('client snapshot request failed')
      }
      return response.data.data.client
    })

  request.catch(() => cache.delete(key))
  cache.set(key, request)

  return request
}

/** Только для тестов. */
export const resetClientSnapshotCache = () => cache.clear()
